import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import {
    SideNavBarContainer,
    BackdropSideBarContainer,
    DesktopNavContanier,
    MobileLinksContainer,
    ProxyUserContainer,
} from './SideNavBar.styled';
import UserPanel from '../userPanel/UserPanel';
import NavLinks from './NavLinks';
import Backdrop from '../backdrop/Backdrop';
import {
    checkImpersonationActive,
    checkProxyActive,
    forbiddenErrorCheck,
} from 'src/utils/util.js';
import { sizes } from 'src/styles/Media.styled';
import ProxyUserList from 'src/pages/more/pages/proxies/proxyBanner/userProxyList';

const SideNavBar = (props) => {
    // const { instance } = useMsal();
    // const dispatch = useDispatch();
    // const [isForbidden, setIsForbidden] = useState(false);
    // const userDetailsAvailable = useSelector(
    //     (state) => state.loginReducer.hybrisUserDetails.uid
    // )
    //     ? true
    //     : false;

    const userDetailsAvailable = useSelector(
        (state) =>
            state.loginReducer.isAuthenticatedWithHybris ||
            JSON.parse(localStorage.getItem('userAuthenticated'))
    );
    const proxyList = useSelector(
        (state) =>
            state.ProxyReducer.proxyList &&
            state.ProxyReducer.proxyList.proxyRecordsForUser
    ); 
    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );

    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );
    const { proxies } = useSelector(
        (state) => state.loginReducer.moreVisibility
    );

    const isPriceOverridePage = useSelector(
        (state) => state.reportUsageRootReducer.isPriceOverridePage
    );

    // const isForbidden = useSelector(
    //     (state) => state.loginReducer.isForbidden
    // );
    const isDestructiveEnabled = useSelector(
        (state) => state.loginReducer.isDestructiveEnabled
    );
    const isDestructive =
        isDestructiveEnabled ||
        (bannerInfo &&
            !checkProxyActive() &&
            !checkImpersonationActive() &&
            bannerInfo.filter(
                (item) => item.messageType === 'userDestructiveMessage'
            ).length > 0);
    // useEffectWithErrorLogging(()=>{
    //     setIsForbidden(true);
    // },[]);
    // useEffectWithErrorLogging(()=>{
    //     forbiddenErrorCheck(instance, dispatch, logoutAPI) ? setIsForbidden(false) : setIsForbidden(true);
    // }, [isForbidden]);

    // const forbiddenError = forbiddenErrorCheck();
    // const [forbiddenError, setForbiddenError] = useState(false);
    // useEffectWithErrorLogging(() => {
    //     setForbiddenError(forbiddenErrorCheck());
    // }, []);
    // const isBanner =
    //     (bannerInfo || []).filter(
    //         (item) => item.messageType == 'userInfoMessage'
    //     ).length > 0 || dismissedBanner;

    return (
        <>
            <BackdropSideBarContainer
                userDetailsAvailable={userDetailsAvailable}
            >
                <Backdrop
                    showBackdrop={props.showSideNavBar}
                    closeBackdrop={props.closeSideNavBar}
                >
                    <SideNavBarContainer>
                        <UserPanel
                            clicked={props.closeSideNavBar}
                            isSideNavBar={true}
                        />

                        <MobileLinksContainer
                            proxyList={proxyList ? true : false}
                            isProxyActive={checkProxyActive()}
                        >
                            {proxies &&
                                !isDestructive &&
                                !forbiddenErrorCheck() &&
                                proxyList &&
                                proxyList.length > 0 && (
                                    <ProxyUserContainer>
                                        {!checkProxyActive() && (
                                            <ProxyUserList
                                                onHide={props.closeSideNavBar}
                                            />
                                        )}{' '}
                                    </ProxyUserContainer>
                                )}
                            <NavLinks
                                clicked={props.closeSideNavBar}
                                isSideNavBar={true}
                            />
                        </MobileLinksContainer>
                    </SideNavBarContainer>
                </Backdrop>
            </BackdropSideBarContainer>
            {!isDestructive && !forbiddenErrorCheck() && (
                <DesktopNavContanier
                    bannerHeight={bannerHeight}
                    isImpersonated={checkImpersonationActive()}
                    userDetailsAvailable={userDetailsAvailable}
                    zIndex={
                        isPriceOverridePage &&
                        window.innerWidth >= sizes.largeDevice &&
                        '1'
                    }
                >
                    <NavLinks />
                </DesktopNavContanier>
            )}
        </>
    );
};

export default SideNavBar;
